import { gql } from '@lichtblick/apollo';

export const GET_WORK_ORDER_APPOINTMENTS = gql`
  query getWorkOrderAppointments_V1($input: GetWorkOrderAppointmentsInput) {
    getWorkOrderAppointments_V1(input: $input) {
      error
      data {
        id
        type
        status
        startDateUtc
        endDateUtc
        expectedDuration
        workflowDefinition {
          id
          name
        }
        startScreenInformation
        workCategory {
          id
          name
          description
          approvalState
          numberOfSubmitted
          numberOfResubmitted
          modifiedAtUtc
          numberOfBlockedFields
          workGroups {
            id
            name
            description
            approvalState
            numberOfSubmitted
            numberOfSubmitted
            numberOfResubmitted
            modifiedAtUtc
            numberOfBlockedFields
          }
        }
        qualityManager {
          id
          eMail
          firstName
          lastName
        }
        teams {
          id
          name
        }
      }
    }
  }
`;

export const GET_SINGLE_ORDER_CATEGORIES = gql`
  query getWorkOrderStatus_V1($input: GetWorkOrderStatusInput!) {
    getWorkOrderStatus_V1(input: $input) {
      error
      data {
        id
        name
        approvalState
        appointments {
          id
          status
          constructedByTeams {
            id
            name
          }
          workCategory {
            description
            id
            name
            modifiedAtUtc
            workGroups {
              id
              name
              approvalState
              workItems {
                id
                approvalState
              }
            }
          }
        }
        qualityManager {
          id
          eMail
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_WORK_CATEGORIES = gql`
  query getWorkCategories_V1($input: GetWorkCategoriesInput) {
    getWorkCategories_V1(input: $input) {
      data {
        name
      }
    }
  }
`;
